var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14V10.6667H3.33333V12.6667H5.33333V14H2ZM10.6667 14V12.6667H12.6667V10.6667H14V14H10.6667ZM2 5.33333V2H5.33333V3.33333H3.33333V5.33333H2ZM12.6667 5.33333V3.33333H10.6667V2H14V5.33333H12.6667Z",
    fill: "#5E6366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullscreen);
export default __webpack_public_path__ + "static/media/ICON_FULLSCREEN.e367a10aebe5b422149aa93d24bedac4.svg";
export { ForwardRef as ReactComponent };